/*global jQuery, confirm, customer_id, console, moment, Shopify */
var weekday = new Array(7);
weekday["sunday"] = 0;
weekday["monday"] = 1;
weekday["tuesday"] = 2;
weekday["wednesday"] = 3;
weekday["thursday"] = 4;
weekday["friday"] = 5;
weekday["saturday"] = 6;

var districtMap = [];
districtMap["HK Wanchai"] = ["Wanchai", "Causeway Bay", "Happy Valley", "Tai Hang", "Jardine’s Lookout"];
districtMap["HK Central Area"] = ["Admiralty", "Central", "SOHO", "Mid Level", "Sheung Wan", "The Peak"];
districtMap["HK Western Area"] = ["Sai Ying Pun", "Sai Wan", "Kennedy Town", "Mount Davis"];
districtMap["HK Eastern Area"] = ["Tin Hau", "North Poing", "Quarry Bay", "Tai Koo", "Shay Kei Wan", "Sai Wan Ho", "Chai Wan", "Siu Sai Wan"];
districtMap["HK Southern Area"] = ["Pok Fu Lam", "Cyberport", "Aberdeen", "Wong Chuk Hang", "Ap Lei Chau", "Deep Water Bay", "Repulse Bay", "Hong Kong Parkview", "Stanley", "Shek O", "Big Wave Bay", "Chung Hom Kok", "Tai Tam"]
districtMap["Kowloon"] = ["Kowloon"];

var main = {
    app_domain: "http://app2.jousun.com/",
    //app_domain: "http://stagingapp.jousun.com/",
    customer: [], //this determines if all the data from app has been captured
    customer_id: null,
  	allAvailableTimeslots: null,
	deliverableTimeslots: [],
	cart_earliest_delivery_date: new Date(),
    next_timeslot: [],
    next_timeslot_str: null,
    timeslots: null,
    timeslot_match: false,
    delivery_zone_match: false,
    delivery_zones: null,
    customer_loop: 0,
    check_loop: 0,
    signup_count: 0,
  	visited: 0,
   
    init: function () {
        "use strict";
        main.setCustomer(); //gets the customer from the server
        main.setNextTimeslot();  //sets and displays next timeslot from the server
        main.setCustomerId(); //sets the customer id from the page
		
  		var restricted_day = false;
      	var preorder_duration = 0;
      
      	if ($('#cartform').length) {
          main.getAvailableTimeslots();
          
          var variants_combined = [];
          $('#cartform span.item-variants').each(function(){
  			variants_combined.push($(this).text());
          })
          restricted_day = main.day_of_week_constrain(variants_combined);
          preorder_duration = main.days_to_prepare_preorder(variants_combined);
        }   

		main.setTimeslots(restricted_day, preorder_duration) //gets the timeslots from the server        
      
        main.setDeliveryZones(); //get the delivery zones from the server
        //loads anything with backstretch

        //auto load and check
        //for account/addresses and cart page.
        if (jQuery('.cart').length > 0 && getURLParameter('show') == 'delivery-information') {
            main.loopAndCheck("main.customer.length == 0 || main.next_timeslot.start_time == 0", "main.setSelectedDeliveryZone(); main.setSelectedTimeslot();");
        }

        //check free delivery info
        if (jQuery('.cart').length > 0) {
            var total_price = parseInt(jQuery('.free-delivery').data('total_price'));
            if (total_price <= 0) {
                jQuery('.free-delivery').text('You have free delivery!');
            }
        }

        if (jQuery('.customers-addresses').length > 0) {
            main.loopAndCheck("main.customer.length == 0 || main.next_timeslot.start_time == 0", "main.setSelectedDeliveryZone(); main.setSelectedTimeslot();");
        }

        //dynamically set product width
        main.setMainProductsWidth();
        main.setOverlayProductsWidth();

        //dynamically set all containers to be the same height as the first
        main.setProductHeight();
        jQuery(window).resize(function () {
            main.setProductHeight();
        });

        //resizing window will readjust the product displays
        jQuery(window).resize(function () {
            main.setMainProductsWidth();
            main.setOverlayProductsWidth();
        });

        //dynamically add class to buttons that i cannot access
        jQuery('.action_link.action_edit a').addClass('btn btn-success btn-sm');
        jQuery('.action_link.action_delete a').addClass('btn btn-danger btn-sm');

        jQuery('#myModal').on('show.bs.modal', function (e) {
            main.loadProduct(jQuery(e.relatedTarget), jQuery(this));
        });

        jQuery('#addAddress').on('show.bs.modal', function (e) {
            main.loadAddress(jQuery(e.relatedTarget), jQuery(this));
        });

        jQuery('#infoModal').on('show.bs.modal', function (e) {
            main.loadPage(jQuery(e.relatedTarget), jQuery(this));
        });

        jQuery('.btn-load-more').on('click', function (e) {
            e.preventDefault();
            main.loadMoreProducts(jQuery(this));
        });


        jQuery('body').on('click', '.btn-qty-plus', function (e) {
            e.preventDefault();
            var inputobj = jQuery(this).parent().parent().find('.quantity'),
                init_qty = parseInt(inputobj.val());

            inputobj.val(init_qty + 1);
        });

        jQuery('body').on('click', '.btn-qty-minus', function (e) {
            e.preventDefault();
            var inputobj = jQuery(this).parent().parent().find('.quantity'),
                init_qty = parseInt(inputobj.val());

            if (init_qty !== 1) {
                inputobj.val(init_qty - 1);
            }
        });

        //hijack checkout button to make checks before going out
        jQuery('body').on('submit', 'form#cartform', function (e) {
            //only do a form check when its in the delivery information checking
            //page.  Not when updating.  If update just return true.
          

            if (getURLParameter('show') == 'delivery-information') {
                return main.goCheckout();
            } else {
                //process update
              
                var form = jQuery(this),
                    thedata = jQuery(this).serialize(),
                    btnobj = jQuery('#update-cart');
                jQuery.ajax({
                    url: form.attr('action'),
                    dataType: "json",
                    data: thedata,
                    type: "post",
                    beforeSend: function (e) {
                        btnobj.button('loading');
                    },
                    error: function (e) {
                        //console.log(e);
                        btnobj.button('reset');
                    },
                    success: function(response) {
                        //console.log(response);
                        btnobj.button('reset');
                        location.href = "/";
                    }
                });

                return false;
            }
        });

        //hijack checkout button to make checks before going out
        //this is for the account/address page
        jQuery('body').on('submit', '#add_address form#address_form_new', function (e) {
            if  (main.goCreateAddress()) {
                jQuery.ajax({
                    url: form.attr('action'),
                    dataType: "html",
                    data: thedata,
                    type: "post",
                    beforeSend: function (e) {
                        $('.btn-add-address').button('loading');
                    },
                    error: function (e) {
                        //console.log(e);
                        $('.btn-add-address').button('reset');
                    },
                    success: function(response) {
                        $('.btn-add-address').button('reset');
//                         console.log(response);
                        location.reload();
                    }
                });
            } else {
                return false;
            }
        });

        //this is for the overlay in the cart page
        jQuery('body').on('submit', '.modal-content form#address_form_new', function (e) {
            var form = jQuery(this);
            var thedata = jQuery(this).serialize();
            if  (main.goCreateAddress()) {
                jQuery.ajax({
                    url: form.attr('action'),
                    dataType: "html",
                    data: thedata,
                    type: "post",
                    beforeSend: function (e) {
                        $('.btn-add-address').button('loading');
                    },
                    error: function (e) {
                        //console.log(e);
                        $('.btn-add-address').button('reset');
                    },
                    success: function(response) {
                        //console.log(response);
                        $('.btn-add-address').button('reset');
                        location.reload();
                    }
                });
            } else {
                return false;
            }
        });

        jQuery('body').on('change', '#delivery-zone', function (e) {
            main.updateCustomerDeliveryZone(main.customer_id, jQuery(this).val());
        });

        jQuery('body').on('change', '#timeslots', function (e) {
            main.updateCustomerTimeslot(main.customer_id, jQuery(this).val());
        });

        jQuery('body').on('submit', 'form#address_form_new', function (e) {
            return false;
        });

        jQuery('body').on('click', '.delivery-type-btn', function (e) {
            e.preventDefault();
            var radio = jQuery(this).data('id');

            //remove all selected class, then add selected class to btn
            jQuery('.delivery-type-btn').removeClass('selected');
            jQuery(this).addClass('selected');
            jQuery('#' + radio).prop('checked', true);
        });
      
        jQuery('body').on('click', '.self-pick-up-btn', function (e) {
            e.preventDefault();
            var radio = jQuery(this).data('id');
            //remove all selected class, then add selected class to btn
            jQuery('.self-pick-up-btn').removeClass('selected');
            jQuery(this).addClass('selected');
            jQuery('#' + radio).prop('checked', true);
            if (radio == "self-pickup") {
              $('.self-pick-up-address').show();
              $('.delivery-address').hide();
            } else {            
              $('.self-pick-up-address').hide();
              $('.delivery-address').show();
            }
        });
      
      
//         $('.product .quick-add').mouseenter(function() {
//           $(this).show();
//           $(this).siblings('.image-cover').show();
//           return false;
//         });
      
//         $('.product .quick-add').mouseleave(function() {
//           $(this).hide();
//           $(this).siblings('.image-cover').hide();
//           return false;
//         });
      
//         $('.product .image-cover').mouseenter(function() {
//           $(this).siblings('.quick-add').show();
//           $(this).show();
//           return false
//         });
      
//         $('.product .image-cover').mouseleave(function() {
//           $(this).siblings('.quick-add').hide();
//           $(this).hide();
//           return false
//         });
      
	    jQuery('.bodycontent .product, .search .product').mouseenter(function() {
          if ($('.quick-add', this).is(":hidden")) {  
			$('.quick-add', this).show();
			$('.image-cover', this).show();
          }  
        });
                  
	    jQuery('.bodycontent .product, .search .product').mouseleave(function() {
          if ($('.quick-add', this).is(":visible")) {  
			$('.quick-add', this).hide();
			$('.image-cover', this).hide();
          }  
        });          
      
	    jQuery('.bodycontent .quick-add-button, .search .quick-add-button').click(function(){
          $(this).closest('.product-form-quick').submit();
        });      
      
      	$('#deliveryDate').datepicker({
	        dateFormat: "dd M yy",
          	onSelect: function(date){
        	  	$('#calendarSelect span.selected').text(date);              	
              	var datesAvailable = main.deliverable_days(main.deliverableTimeslots);
              	var timesAvailable = datesAvailable[main.dateToUTCString(new Date(date))];
              	var timeSelect = $('ul#deliverySelect');
                $('select#timeslots option:first').val("");              
                $('select#timeslots option:first').prop('selected', true);
              	timeSelect.html("");
	            $('button#delivery_time span.selected').text('Delivery Timeslot');
                for (var i = 0; i < timesAvailable.length; i++) {
                  var hour = timesAvailable[i].getHours();
                  if ($('#delivery-zone-hidden').length > 0 && $('#delivery-zone-hidden').val() == "Kowloon" && hour >= 18) {
                    continue;
                  }
                  $('ul#deliverySelect').append("<li><a>" + hour + ":00 - " + (hour + 2) + ":00" + "</a></li>");
                  $('ul#deliverySelect li').click(function(){
                    var dateInFormat = new Date(date)
                    var index = $("ul#deliverySelect li").index(this);
                    var timeslot = dateInFormat.getFullYear() + "-" + (dateInFormat.getMonth() + 1) + "-" + dateInFormat.getDate() + " " + timesAvailable[index].getHours() + ":00:00";
                    $('button#delivery_time span.selected').text($('a', this).text());
                    $('select#timeslots option:first').val(timeslot);
                    $('select#timeslots option:first').prop('selected', true);
                  })
                }

	        },
          
        	beforeShowDay: function(date){
              var datesAvailable = Object.keys(main.deliverable_days(main.deliverableTimeslots));
              var dateClone = new Date(date);
              if (datesAvailable.indexOf(main.dateToUTCString(new Date(dateClone.setHours(0,0,0,0)))) > -1){                
                return [true];
              }

              return [false];
        	}
      });
      
        $('#calendarSelect').click(function(){
          $('#deliveryDate').show().focus().hide();
        });
      
      if ($('.mobile-only').is(":visible")) {
        $('.product-count.quantity','.desktop-only').each(function(){
          $(this).prop( "disabled", true );
        })
      } else {
        $('.product-count.quantity','.mobile-only').each(function(){
          $(this).prop( "disabled", true );
        })
      };
      
      if ($('.recent-purchases').length) {
        $('.repeating-purchase', '.recent-purchases').each(function(){
          if (typeof $(this).data("id") !== undefined) {
            var id = $(this).data("id");
            $('.product-loop[data-id="' + id + '"]', '.recent-purchases').each(function(){
              var newCount = parseInt($(this).attr("data-count")) + 1;
              $(this).attr("data-count", newCount);
            }) 
          }
        });
        
        $($('.product-loop', '.recent-purchases').sort(function(a,b){
          return parseInt($(a).attr("data-count")) - parseInt($(b).attr("data-count"));
        }).get().reverse()).each(function(){
          $('.products').append($(this).html());
        });
        
       	jQuery('.bodycontent .product, .search .product').mouseenter(function() {
          if ($('.quick-add', this).is(":hidden")) {  
			$('.quick-add', this).show();
			$('.image-cover', this).show();
          }  
        });
                  
	    jQuery('.bodycontent .product, .search .product').mouseleave(function() {
          if ($('.quick-add', this).is(":visible")) {  
			$('.quick-add', this).hide();
			$('.image-cover', this).hide();
          }  
        });          
      
	    jQuery('.bodycontent .quick-add-button, .search .quick-add-button').click(function(){
          $(this).closest('.product-form-quick').submit();
        }); 
        
        $('.favourite').show();
      }  
      
      if ($('#addresses_list').length) {
        $('li', '#addresses_list').click(function(){
          var selected = $('a', this);
          $('#default_address_selector .selected').text(selected.text());
          $(".value.name").text(selected.data("name"));
          $(".value.phone").text(selected.data("phone"));
          $(".value.address").text(selected.data("address"));
          $(".value.zone").text(selected.data("zone"));
          
          $('#address_default_address_' + selected.data("id")).prop('checked', true);
          $('form#address_form_' + selected.data("id")).submit();
        })
      }
      
      if ($('.action_set_default').length) {
          $('.action_set_default').click(function() {
            var id = $(this).data('id');
          	$('#address_default_address_' + id).prop('checked', true);
            $('form#address_form_' + id).submit();
          })
      }  
      
      if ($('#self-pickup').length) {
        $('#self-pickup').change(function(){
          alert('');
          if ($('#self-pickup:checked').length > 0) {
            $('.self-pick-up-address').show();
            $('.delivery-address').hide();
          }
        })
      }
                  
      if ($('#delivery-service').length) {
        $('#delivery-service').change(function(){
                    alert('');
          if ($('#delivery-service:checked').length > 0) {
            $('.self-pick-up-address').hide();
            $('.delivery-address').show();
          }
        })
      }

      main.urlEvents();
    },
    checkSignup: function () {
      	//check visited status
        if (typeof(Cookies.set('visited')) == 'undefined') {
          Cookies.set('visited', '1', { expires: 1 }); 
          main.visited = 1;
        } else {
          var visited = Cookies.set('visited');
          visited++;
          Cookies.set('visited', visited);
          main.visited = visited;
        }
      
        if (main.visited > 1) {
          return;
        }
      
        //lets get the cookie first
        if (typeof(Cookies.get('signup_count')) == 'undefined') {
            //if cookie isn't available, lets create it
            Cookies.set('signup_count', 1);
            main.signup_count = 1;
        } else {
            //lets get the cookie, increment and then store it.
            var count = Cookies.set('signup_count');
            count++;
            Cookies.set('signup_count', count);
            main.signup_count = count;
        }
        console.log('signup count: ' + main.signup_count);
        if (main.signup_count <= 5) {
            $('#signupModal').modal('show');
            $('#signupModal').on('shown.bs.modal', function(e) {
              main.updateModalBackDropHeight('.modal-backdrop.in', '.modal-dialog');
            });
        }
    },
    setProductHeight: function (timer) {
        var timer = (typeof(timer) != 'undefined') ? timer : 2000;
        setTimeout(function () {
            if (jQuery('.products .product:nth-child(1)').height() > 250) {
                jQuery('.products .product').height(jQuery('.products .product:nth-child(1)').height());
            }
        }, timer);
    },
    urlEvents: function () {
        //capture any actions
        if (jQuery('form#cartform').length > 0 && getURLParameter('action') == 'checkout') {
            main.loopAndCheck('main.customer.length == 0', "main.goCheckout()");
        }

        //in addresses page, display orders
        if (getURLParameter('show') == 'orders') {
            jQuery('.orders-container').show();
            jQuery('.addresses-container').hide();
        }

        //in cart page, display delivery information
        if (getURLParameter('show') == 'delivery-information') {
            jQuery('.delivery-information').show();
            jQuery('.cart-information').hide();
        }

        //redirector
        var redirect = getURLParameter('redirect');
        if (redirect != 'null') {
            location.href = getURLParameter('redirect');
        }

        //force display of add address
        if (getURLParameter('action') == 'create-address') {
            jQuery('#add_address').show();
        }

        //append parameters
        var form = getURLParameter('form');
        var appendto = getURLParameter('appendtoaction');
        if (appendto != 'null' && form != 'null') {
            var action = jQuery('#' + form).attr('action');
            action = action + '?' + appendto;
            jQuery('#' + form).attr('action', action);
        }

        //contact us
        var faqpage = getURLParameter('faqpage');
        if (faqpage != 'null') {
            main.toggleAccordion(faqpage);
        }
    },
    toggleAccordion: function (faqpage) {
        jQuery('#accordion .panel-collapse').removeClass('in');
        jQuery('#' + faqpage).collapse('toggle');
        setTimeout(function () {
            jQuery(document).scrollTop( jQuery("#" + faqpage).offset().top );
        }, 1000);
    },
    goCheckout: function () {
        loader.showLoader('body');

//         if (main.customer.delivery_zones.length === 0) {
//             swal('Error!', 'Please select a delivery zone to continue checkout out.', 'error');
//             loader.hideLoader();
//             return false;
//         }
        //console.log(main.customer.delivery_zones);
        //swal('Error!', 'Sorry, we are just doing some quick maintenance, will be back in a few minutes.', 'error');
        //loader.hideLoader();
        //return false;
        if (main.customer.delivery_zones.friendly === "NT") {
            swal('Error!', 'Sorry, we currently cannot delivery to this zone.', 'error');
            loader.hideLoader();
            return false;
        }
        if (!jQuery(".delivery-type-radio:checked").val() && $('#delivery-service:checked').length > 0) {
            swal('Error!', 'Sorry, please select a delivery type.', 'error');
            loader.hideLoader();
            return false;
        }

        if (jQuery.trim(jQuery('#timeslots').val()) === 'Please select a time for delivery...' || jQuery.trim(jQuery('#timeslots').val()) === '') {
            swal('Error!', 'Sorry, please select a delivery time.', 'error');
            loader.hideLoader();
            return false;
        }

        if (jQuery.trim(jQuery('#delivery-zone-hidden').val()) === 'Please select a delivery zone...' || typeof(jQuery('#delivery-zone-hidden').val()) == 'undefined') {
            swal('Error!', 'Sorry, an address with delivery zone is required.', 'error');
            loader.hideLoader();
            return false;
        }
console.log('pre-pre-submit');
      if ($('#delivery-chargable').length > 0 && $('#delivery-service:checked').length > 0) {        
        var HKSouthernDistricts = ["Stanley", "Shek O", "Big Wave Bay", "Chung Hom Kok", "Tai Tam"];
        var KowloonDistricts = ["Kowloon"];
        
          	console.log('pre-submit');
        if (KowloonDistricts.indexOf($('#delivery-zone-hidden').val()) > -1) {                
            $('.product-form-quick:eq(2)').submit();
        } else if (HKSouthernDistricts.indexOf($('#delivery-zone-hidden').val()) > -1) {
            $('.product-form-quick:eq(1)').submit();
        } else {
          	console.log('submit');
            $('.product-form-quick:eq(0)').submit();
        }        
      }  
      
        return true;
    },
    goCreateAddress: function () {
        if (jQuery.trim(jQuery('#address_first_name_new').val()) === '') {
            swal('Error!', 'Sorry, please enter a first name.', 'error');
            loader.hideLoader();
            return false;
        }

        if (jQuery.trim(jQuery('#address_address1_new').val()) === '') {
            swal('Error!', 'Sorry, please enter an address.', 'error');
            loader.hideLoader();
            return false;
        }

        if (jQuery.trim(jQuery('#delivery-zone').val()) === 'Please select a delivery zone...') {
            swal('Error!', 'Sorry, please select a delivery zone.', 'error');
            loader.hideLoader();
            return false;
        }

        if (jQuery.trim(jQuery('#address_phone_new').val()) === '') {
            swal('Error!', 'Sorry, please enter a phone number.', 'error');
            loader.hideLoader();
            return false;
        }

        return true;
    },
    setOverlayProductsWidth: function () {
        var product_width = 0,
            products_width = 0,
            total_products_per_row = 0,
            container_width = 0;
        if (jQuery('.modal-content .product').length > 0) {
            product_width = jQuery('.modal-content .product').outerWidth();
            container_width = jQuery('.modal-content').width();
        } else {
            product_width = jQuery('body.product .products-related .product').outerWidth();
            container_width = jQuery('body.product').width();
        }

        total_products_per_row = Math.floor(container_width/product_width);
        products_width = total_products_per_row * product_width;
        //console.log('products_width: ' + products_width);
        //console.log('product_width: ' + product_width);
        //console.log('total_products_per_row: ' + total_products_per_row);
        //console.log('container_width: ' + container_width);
        jQuery('.modal-content .products, body.product .products').width(products_width);
    },
    setMainProductsWidth: function () {
        var product_width = 0,
            products_width = 0,
            total_products_per_row = 0,
            body_width = 0;
        product_width = jQuery('.product').outerWidth();
        body_width = jQuery('body').width();
        total_products_per_row = Math.floor(body_width/product_width);
        products_width = total_products_per_row * product_width;
        /*//console.log('products_width: ' + products_width);
        //console.log('product_width: ' + product_width);
        //console.log('total_products_per_row: ' + total_products_per_row);
        //console.log('body_width: ' + body_width);*/
        jQuery('.products.collection, .products.search, .index .products').width(products_width);
    },
    //loops through check and performs action when the check is satisfied.
    loopAndCheck: function(check, action) {
        if (main.check_loop == 0) {
            loader.showLoader('body');
        }
        if (main.check_loop < 4) {
            if (eval(check)) {
                setTimeout(function() { main.loopAndCheck(check, action); }, 1000);
            } else {
                eval(action);
                loader.hideLoader();
            }
            main.check_loop++;
        } else {
            loader.hideLoader();
        }
    },
    populateTimeslotDropdown: function () {
        "use strict";
        var text = '',
            option = '';

        //see if timeslot dropdown and timeslots available
        if (jQuery("#timeslots").length > 0 && main.timeslots.length > 0) {
            for (var i = 0; i < main.timeslots.length; i++) {
                //console.log(main.customer.delivery_timeslot);
                //console.log(main.timeslots[i].start_time);
                //jQuery("#timeslots").append('<option value="' + main.timeslots[i].start_time + '">' + moment(main.timeslots[i].start_time).calendar() + '</option>');
                text = moment(main.timeslots[i].start_time).format('dddd') + ' at ' +
                    moment(main.timeslots[i].start_time).format('h:mm') + '-' +
                    moment(main.timeslots[i].end_time).format('h:mma');

                //append the text full
                if (main.timeslots[i].slots == 0) {
                    text += ' (FULL)';
                }

                option = jQuery('<option />').val(main.timeslots[i].start_time).text(text);
                if (main.timeslots[i].slots == 0) {
                    option.attr('disabled', 'disabled');
                    //option = '';
                }

                if (option != '') {
                    jQuery("#timeslots").append(option);
                }
            }

            main.setSelectedTimeslot();
        }
    },

    /**
     * Initiates the delivery timezone setting, grabs data from server.
     * @returns {undefined}
     */
    setDeliveryZones: function () {
        "use strict";
        jQuery.ajax({
            url: main.app_domain + "delivery_zones/all?callback=?",
            dataType: "jsonp",
            type: "post",
            beforeSend: function (e) {
                //console.log('getting...');
            },
            error: function (e) {
                //console.log(e);
            },
            success: function (response) {
                //console.log(response);
                if (response.success === true) {
                    main.delivery_zones = response.data;
                    main.populateDeliveryZonesDropdown();
                }
            }
        });
    },

    populateDeliveryZonesDropdown: function () {
        "use strict";
        var text = '',
            option = '';

        if (main.customer.customer_id === 0) {
            jQuery('#delivery-zone').replace('<a href="/account/login">Login first</a>');
        }
        //see if timeslot dropdown and timeslots available
        if ($('select.delivery-zone').length > 0 && main.delivery_zones.length > 0) {
          $('select.delivery-zone').each(function(){
//             for (var i = 0; i < main.delivery_zones.length; i++) {
//                 text = main.delivery_zones[i].name;
//                 if (text == 'Hong Kong island (South)') {
// 					text = 'Hong Kong island (Stanley, Shek O, Big Wave Bay, Chung Hom Kok, Tai Tam)';
//                 }
//                 option = jQuery('<option />').val(main.delivery_zones[i].friendly).text(text);
//                 if (main.delivery_zones[i].active == 0) {
//                     option.attr('disabled', 'disabled');
//                 }
//                 $(this).append(option);
//             }
            
            for (var district in districtMap) {
              var options = "";
              for (var j = 0; j < districtMap[district].length; j++) {
                options += '<option value="' + districtMap[district][j] + '">' + districtMap[district][j] + '</option>';
//                   jQuery('<option />').val(districtMap[district][j]).text(districtMap[district][j]);
              };
              var optionGroup = $('<optgroup  />').attr('label', district).html(options);
              $(this).append(optionGroup);
            }

            main.setSelectedDeliveryZone();
          })          

        }
    },

    //sets the dropdown if available
    setSelectedTimeslot: function () {
        "use strict";
        if (jQuery('#timeslots').length > 0 && main.customer.delivery_timeslot !== '' && moment(main.customer.delivery_timeslot) >= moment(main.next_timeslot.start_time)) {
            jQuery('#timeslots option[value="' + main.customer.delivery_timeslot + '"]').attr("selected", true);

            //indicate if the timeslot was a match with the list && weather its past the last timeslot
            if (jQuery('#timeslots option[value="' + main.customer.delivery_timeslot + '"]').length > 0 && moment(main.customer.delivery_timeslot) >= moment(main.next_timeslot.start_time)) {
                main.timeslot_match = true;
            }
        }
    },

    //sets the dropdown if available
    setSelectedDeliveryZone: function () {
        "use strict";

        if ($('select.delivery-zone').length > 0) {
          $('select.delivery-zone').each(function(){

            $('option[value="' + $(this).data('zone') + '"]', this).attr("selected", true);
          })
//             $('select.delivery-zone option[value="' + main.delivery_zones.friendly + '"]').attr("selected", true);

//             //indicate if the zone was a match with the list
//             if (jQuery('select.delivery-zone option[value="' + main.delivery_zones.friendly + '"]').length > 0) {
//                 main.delivery_zone_match = true;
//             }
        }
    },

    updateCustomerTimeslot: function (customer_id, timeslot) {
        "use strict";
        jQuery.ajax({
            url: main.app_domain + "customer/set_timeslot?callback=?",
            dataType: "jsonp",
            data: {
                customer_id: main.customer_id,
                timeslot: timeslot
            },
            type: "get",
            beforeSend: function (e) {
                main.timeslot_match = false;
                loader.showLoader('body');
                //console.log('getting...');
            },
            error: function (e) {
                //console.log(e);
                loader.hideLoader();
            },
            success: function (response) {
                //console.log(response);
                //location.reload();
                loader.hideLoader();
                if (response.success === true) {
                    main.customer = [];
                    main.setCustomer();
                    main.loopAndCheck('main.customer.length == 0', 'main.setSelectedTimeslot()');
                }
            }
        });
    },
    updateCustomerDeliveryZone: function (customer_id, delivery_zone) {
        "use strict";
        jQuery.ajax({
            url: main.app_domain + "customer/set_delivery_zone?callback=?",
            dataType: "jsonp",
            data: {
                customer_id: main.customer_id,
                delivery_zone: delivery_zone
            },
            type: "get",
            beforeSend: function (e) {
                main.delivery_zone_match = false;
                loader.showLoader('body');
                //console.log('getting...');
            },
            error: function (e) {
                //console.log(e);
                loader.hideLoader();
            },
            success: function (response) {
                //console.log(response);
                //location.reload();
                loader.hideLoader();
                if (response.success === true) {
                    main.customer = [];
                    main.setCustomer();
                    main.loopAndCheck('main.customer.length == 0', 'main.setSelectedDeliveryZone()');
                }
            }
        });
    },
    setCustomer: function () {
        "use strict";
        jQuery.ajax({
            url: main.app_domain + "customer/detail?callback=?",
            dataType: "jsonp",
            data: {
                customer_id: customer_id
            },
            type: "get",
            beforeSend: function (e) {
                //console.log('getting...');
            },
            error: function (e) {
                //console.log(e);
            },
            success: function (response) {
                //console.log(response);
                if (response.success === true) {
                    main.customer = response.data;
                }
            }
        });
    },
    setCustomerId: function () {
        "use strict";
        main.customer_id = customer_id; //this is set on the page if available
    },
  	
   	getAvailableTimeslots: function () {
        jQuery.ajax({
            url: main.app_domain + "timeslots/preorder/9/7?callback=?",
            dataType: "jsonp",
            type: "post",
            beforeSend: function (e) {
//                 console.log('getting...');
            },
            error: function (e) {
//                 console.log(e);
            },
            success: function (response) {
//                 console.log(response);
                if (response.success === true) {
                    main.allAvailableTimeslots = response.data;
                  	main.updateDeliveryTimeForItems();
                }
            }
        });
    },
  
    setTimeslots: function (restricted_day, preparing_days) {
        "use strict";
      	var endpointURL;
      	if (restricted_day != false) {
          var dateRange = 10;
          endpointURL = main.app_domain + "timeslots/day_of_week/" + dateRange + "/" + restricted_day + "/" + preparing_days +"/?callback=?"
        } else if (preparing_days > 0) {
          var limit = 3;
          endpointURL = main.app_domain + "timeslots/preorder/" + limit + "/" + preparing_days +"/?callback=?"
    	}else {
          endpointURL = main.app_domain + "timeslots/today?callback=?"
        }  
      
        jQuery.ajax({
            url: endpointURL,
            dataType: "jsonp",
            type: "post",
            beforeSend: function (e) {
                //console.log('getting...');
            },
            error: function (e) {
                //console.log(e);
            },
            success: function (response) {
                //console.log(response);
                if (response.success === true) {
                    main.timeslots = response.data;
                    main.populateTimeslotDropdown();
                }
            }
        });
    },
    setNextTimeslot: function () {
        "use strict";
        jQuery.ajax({
            url: main.app_domain + "timeslots/next?callback=?",
            dataType: "jsonp",
            type: "post",
            beforeSend: function (e) {
                //console.log('Getting next timeslot...');
            },
            error: function (e) {
                //console.log(e);
            },
            success: function (response) {
                //console.log(response);
                if (response.success === true) {
                    var date_str = moment(response.data.start_time).calendar();
                    //jQuery("#next-delivery-time").text(date_str);
                    date_str = date_str.replace(/:00 /, '');
                    main.next_timeslot = response.data;
                    main.next_timeslot_str = date_str;
                    main.displayNextTimeslot();
                }
            }
        });
    },
    displayNextTimeslot: function () {
        "use strict";
        if (main.next_timeslot_str != null) {
            jQuery(".next-delivery-time").text(main.next_timeslot_str);
        } else {
            main.setNextTimeslot();
        }
    },
    loadAddress: function(btnobj, modalobj) {
        "use strict";
        var button = btnobj, // Button that triggered the modal
            thehref = button.data('href'),
            //var recipient = button.data('whatever'); // Extract info from data-* attributes
            // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
            // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
            modal = modalobj;
        //modal.find('.modal-title').text('New message to ' + recipient);
        //modal.find('.modal-body input').val(recipient);
        jQuery.ajax({
            url: thehref,
            dataType: "html",
            type: "get",
            beforeSend: function (e) {
                modal.find('.modal-content').html('<div class="loader-overlay"><i class="fa fa-refresh fa-spin fa-2x fa-jousun"></i></div>');
            },
            error: function (e) {
                //console.log(e);
            },
            success: function (response) {
                //console.log(response);
                jQuery('.loader-overlay').fadeOut(function () {
                    var filteredData = jQuery(response).find('#add_address').html();
                    modal.find('.modal-content').html(filteredData).fadeIn();
                });
                setTimeout(function () {
                    main.populateDeliveryZonesDropdown();
                }, 1000);

                main.updateModalBackDropHeight('.modal-backdrop.in', '.modal-dialog');
            }
        });
    },
    loadPage: function(btnobj, modalobj) {
        "use strict";
        var button = btnobj, // Button that triggered the modal
            thehref = button.data('href'),
            //var recipient = button.data('whatever'); // Extract info from data-* attributes
            // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
            // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
            modal = modalobj;
        //modal.find('.modal-title').text('New message to ' + recipient);
        //modal.find('.modal-body input').val(recipient);
        jQuery.ajax({
            url: thehref,
            dataType: "html",
            type: "get",
            beforeSend: function (e) {
                modal.find('.modal-body').html('<div class="loader-overlay"><i class="fa fa-refresh fa-spin fa-2x fa-jousun"></i></div>');
            },
            error: function (e) {
                //console.log(e);
            },
            success: function (response) {
                //console.log(response);
                jQuery('.loader-overlay').fadeOut(function () {
                    var filteredData = '';

                    var faqpage = getURLParameter('faqpage', thehref);
                    if (faqpage != 'null') {
                        filteredData = jQuery(response).find('#' + faqpage).html();
                    } else {
                        filteredData = jQuery(response).find('#page').html();
                    }

                    modal.find('.modal-body').html(filteredData).fadeIn(function() {
                        jQuery('.modal-body .container').removeClass('container');

                        main.updateModalBackDropHeight('#infoModal .modal-backdrop.in', '#infoModal .modal-dialog');
                    });
                });
            }
        });
    },
    loadProduct: function (btnobj, modalobj) {
        "use strict";
        var button = btnobj, // Button that triggered the modal
            thehref = button.data('href'),
            //var recipient = button.data('whatever'); // Extract info from data-* attributes
            // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
            // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
            modal = modalobj;
        //modal.find('.modal-title').text('New message to ' + recipient);
        //modal.find('.modal-body input').val(recipient);
        jQuery.ajax({
            url: thehref,
            dataType: "html",
            type: "get",
            beforeSend: function (e) {
                modal.find('.modal-content').html('<div class="loader-overlay"><i class="fa fa-refresh fa-spin fa-2x fa-jousun"></i></div>');
            },
            error: function (e) {
                //console.log(e);
            },
            success: function (response) {
                //console.log(response);
                jQuery('.loader-overlay').fadeOut(function () {
                    //modal.find('.modal-content').css('display', 'none');
                    var filteredData = jQuery(response).find('.product-container').html();
                    modal.find('.modal-content').html(filteredData).fadeIn();
                    Shopify.AjaxifyCart.init();
                    main.setOverlayProductsWidth();

                    main.updateModalBackDropHeight('.modal-backdrop.in', '.modal-dialog');
                });

            }
        });
    },
    loadMoreProducts: function (btnobj) {
        "use strict";
        var thehref = btnobj.attr('href'),
            newhref = '',
            newhref_nexturl = '',
            currentpage = btnobj.data('current_page'),
            nextpage = parseInt(currentpage) + 1,
            nextpage_nexturl = parseInt(currentpage) + 2,
            urlparts = thehref.split("?"),
            searchparts = [],
            newparts = [],
            newparts_nexturl = [],
            part = null;

        //if there are url params
        if (urlparts.length > 1) {
            searchparts = urlparts[1].split("&");
        }

        //determine search parts
        //console.log(searchparts);
        //console.log(urlparts);
        //console.log(searchparts.length);

        if (searchparts.length === 1) { //if there are parts
            part = searchparts[0];
            //console.log(part);
            if (part.match('page')) {
                newparts.push('page=' + nextpage);
                newparts_nexturl.push('page=' + nextpage_nexturl);
            } else {
                newparts.push(part);
                newparts_nexturl.push(part);
            }
        } else {
            //console.log(searchparts);
            for (var i=0; i < searchparts.length; i++) {
                part = searchparts[i];
                //console.log(part);
                if (part.match('page')) {
                    newparts.push('page=' + nextpage);
                    newparts_nexturl.push('page=' + nextpage_nexturl);
                } else {
                    newparts.push(part);
                    newparts_nexturl.push(part);
                }
            }
        }

        //lets join everything back to create the href
        newhref = urlparts[0] + '?' + newparts.join("&");
        newhref_nexturl = urlparts[0] + '?' + newparts_nexturl.join("&");
        //console.log(newhref);
        //console.log(newhref_nexturl);

        jQuery.ajax({
          url: newhref,
          dataType: "html",
          type: "get",
          beforeSend: function (e) {
            btnobj.button('loading');
          },
          error: function (e) {
            //console.log(e);
            btnobj.button('reset');
          },
          success: function(response) {
            btnobj.button('reset');

            //lets assign these values
            btnobj.attr('href', newhref_nexturl);
            btnobj.data('current_page', nextpage);
            var filteredData = jQuery(response).find('.products').html();
            if (jQuery.trim(filteredData) == '') { //no more results!
                btnobj.hide();
            } else {
                jQuery('.products').append(filteredData);
            }

            main.setProductHeight(500);
          }
        });
    },
    updateModalBackDropHeight: function(modalBackdrop, modalDialog) {
        setTimeout(function() {
            if (jQuery(modalDialog).height() > jQuery(window).height()) {
                jQuery(modalBackdrop).height(jQuery(modalDialog).height() + 100);
            }
        }, 500);
    },
  
    preOrderType: function(variant) {
      if (variant.match(/\d+ days? pre-order/i) != null) {
        return 'order-in-advance';
      } else {
        return 'specific-day';
      }
    },
  
    preOrderVariant: function(variants) {
      var variants_array = variants.split(' / ');
      for (var i = 0; i < variants_array.length; i++) {  
        for (var day in weekday) {
          if (variants_array[i].toLowerCase().indexOf(day) > -1) {
            return variants_array[i];
          }
        }
      	if (variants_array[i].match(/\d+ days? pre-order/i) != null) {
        	return variants_array[i];
      	}       
      }  
      return false;
    },
  
    stringToTime: function(timeString){
      var formattedString = timeString.replace(' ', 'T').concat('Z');
      var localTime = new Date(formattedString);
      var utcTime = localTime.setTime(localTime.getTime() + localTime.getTimezoneOffset()*60*1000);
      return new Date(utcTime);
    },
  
    commonTimeslots: function(baseTimeslots, newTimeslots) {
      var common = [];
      var newTimeslotsInTimeFormat = []
      for(var i = 0; i< newTimeslots.length; i++){
        newTimeslotsInTimeFormat.push(main.stringToTime(newTimeslots[i]['start_time']));
      }
        
      if (baseTimeslots == null) {
        return newTimeslotsInTimeFormat;
      }
      
      for (var i = 0; i < baseTimeslots.length; i++) { 
        for (var j = 0; j < newTimeslotsInTimeFormat.length; j++) { 
          if (newTimeslotsInTimeFormat[j].valueOf() == baseTimeslots[i].valueOf()) {
            common.push(baseTimeslots[i]);
          }
        }
      } 
//             console.log(common);
      return common;
    },
    updateDeliveryTimeForItems: function() {
      var allTimeslots = main.allAvailableTimeslots;
      var conflict_flag = false;
      var specific_day = null;
      var specific_day_items = [];
      main.deliverableTimeslots = null;
      $('.individual-item-variant').each(function(){
        var variants = $(this).text();
        var preOrderVariant = main.preOrderVariant(variants);
        var earliest_delivery_date;
        if (preOrderVariant.length) {
          var preOrderType = main.preOrderType(preOrderVariant);
          var variantValue = preOrderVariant.split(' ')[0].toLowerCase();
          var itemTimeslotOptions = allTimeslots[preOrderType][variantValue];  

          if (main.firstAvailableTimeslot(itemTimeslotOptions)) {
            earliest_delivery_date = new Date(main.firstAvailableTimeslot(itemTimeslotOptions)['start_time'].split(' ')[0]);              
          }  
          
          main.deliverableTimeslots = main.commonTimeslots(main.deliverableTimeslots, itemTimeslotOptions);
			
          if (earliest_delivery_date > main.cart_earliest_delivery_date && main.deliverableTimeslots.length > 0) {            
            main.cart_earliest_delivery_date = main.deliverableTimeslots[0];
          }
          
          if (preOrderType == 'specific-day') {
            specific_day_items.push($(this));
            if (specific_day === null) {
              specific_day = variantValue
            } else if (specific_day != variantValue) {
              conflict_flag = true;
            }
          }
          
          var message_dom = $(this).siblings('.preorder-message');
          $(this).siblings('.' + preOrderType).show();
          message_dom.text(preOrderVariant + '- Earliest delivery: ' + earliest_delivery_date.toDateString());
          message_dom.show();
          $('#deliveryDate').datepicker('setDate', earliest_delivery_date);
        } else {
          	var itemTimeslotOptions = allTimeslots["normal"];
            main.deliverableTimeslots = main.commonTimeslots(main.deliverableTimeslots, itemTimeslotOptions);
        }  
      });

      if (main.deliverableTimeslots.length == 0) {
        for (var i = 0; i < specific_day_items.length; i++) {  
          specific_day_items[i].siblings('.preorder-message').css('color', '#AD2E32');
          specific_day_items[i].siblings('.individual-item-title').css('color', '#AD2E32');
        }
        $('.preorder-conflict').show();
      }else if ($('.preorder-notice').length && main.cart_earliest_delivery_date.toDateString() != (new Date()).toDateString()) {        
       	$('.preorder-notice').show();
        $('span', '.preorder-notice').text(main.cart_earliest_delivery_date.toDateString());
      }
    },
  
    firstAvailableTimeslot: function(timeslots) {
      for (var i = 0; i < timeslots.length; i++) {  
        if (timeslots[i]['slots'] > 0) {
          return timeslots[i];
        }
      }
      return false;
    },
  
  	day_of_week_constrain: function (variants_array) {  
		for (var i = 0; i < variants_array.length; i++) {  
          	for (var day in weekday) {
              	if (variants_array[i].indexOf(day) > -1) {
                	return weekday[day];
              	}
          	}
        };  
        return false;
    },
  
  	days_to_prepare_preorder: function (variants_array) {
      	var max_days = 0;
		for (var i = 0; i < variants_array.length; i++) {  
          if (variants_array[i].match(/Preorder: \d+ days in advance/i) != null) {
            var days = variants_array[i].match(/Preorder: \d+ days in advance/i)[0].match(/\d+/)[0];
            max_days = Math.max(max_days, parseInt(days));
          }

        };  
        return max_days;    
  	},
  
    deliverable_days: function(datetime_array) {
      var dates = {};
      for (var i = 0; i < datetime_array.length; i++) {  
        var dateTime = new Date(datetime_array[i]);
        
        var dateFormat = main.dateToUTCString(new Date(dateTime.setHours(0, 0, 0, 0, 0)));        
        if (dates[dateFormat] != undefined) {
          dates[dateFormat].push(datetime_array[i])
        } else {
          dates[dateFormat] = [datetime_array[i]]
        } 
      }   
      return dates;
    },
  
    dateToUTCString: function(date) {
		return date.getUTCFullYear() + "/" + date.getUTCMonth() + "/" + date.getUTCDate();
    }
  	
};

jQuery(document).ready(function() {
    'use strict';
    loader.init('have-bg');
    main.init();
});